export const environment = {
  production: false,
  TENANT_ID: 'https://login.microsoftonline.com/tmnatest.onmicrosoft.com',
  CLIENT_ID: '9d822665-267a-4ec4-83e5-f1002b928b0e',
  REDIRECT_URL: 'https://qa.lios.toyota.com',
  SCOPES: ['https://tmnatest.onmicrosoft.com/e45b42dc-670d-4640-b95b-a24d12e73448/user_impersonation'],
  CLOUDFRONT: 'https://d2y6ep1a58etrt.cloudfront.net',
  log_level: 'debug',
  ADMIN_DS_URI: 'https://api.qa.lios.toyota.com/admin/graphql',
  APM_DS_URI: 'https://api.qa.lios.toyota.com/apm/graphql',
  BILLING_DS_URI: 'https://api.qa.lios.toyota.com/billing/graphql',
  OPERATION_DS_URI : "https://api.qa.lios.toyota.com/operations/graphql",
  FILEDOWNLOAD_PDF_URI : "https://filedownload.qa.lios.toyota.com",
  MAINTENANCE_DS_URI : "https://api.qa.lios.toyota.com/maintenance/graphql",
  manifest: {
    admin: 'https://admin.qa.lios.toyota.com/remoteEntry.js',
    apm: 'https://apm.qa.lios.toyota.com/remoteEntry.js',
    bm: 'https://bm.qa.lios.toyota.com/remoteEntry.js',
    lcm: 'https://lcm.qa.lios.toyota.com/remoteEntry.js',
    cm: 'https://cm.qa.lios.toyota.com/remoteEntry.js',
    drc: 'https://drc.qa.lios.toyota.com/remoteEntry.js',
    gc: 'https://generalcosts.qa.lios.toyota.com/remoteEntry.js',
    ec: 'https://ec.qa.lios.toyota.com/remoteEntry.js',
    lpi: 'https://lpi.qa.lios.toyota.com/remoteEntry.js',
    maintenance: 'https://maintenance.qa.lios.toyota.com/remoteEntry.js',
    mshell: 'https://mshell.qa.lios.toyota.com/remoteEntry.js',
    bshell: 'https://bshell.qa.lios.toyota.com/remoteEntry.js',
    opershell : 'https://opershell.qa.lios.toyota.com/remoteEntry.js',
    operations : 'https://operations.qa.lios.toyota.com/remoteEntry.js'
  },
  TASK_MANAGER: 'https://taskmanager.qa.lios.toyota.com',
  AET: 'https://ts.stage.portal.toyotasupplier.com/aet',
  ALARMS: 'https://alarms.qa.lios.toyota.com',
  FORECAST_ADMIN_DASHBOARD: 'https://ts.stage.portal.toyotasupplier.com/lios/forecast',
  CO2: 'https://liosapps.qa.toyota.com/co2/lp-upload',
  COST_PLANNING: 'https://costplanning.qa.lios.toyota.com',
  EBOI: 'https://eboi.qa.lios.toyota.com',
  TLD: 'https://tld.qa.lios.toyota.com',
  DD: 'https://ts.stage.portal.toyotasupplier.com/lios/delayindex#/delayeddispatch',
  REPORTS: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=11db23f6-28df-4b47-bf4d-03bb6cab9246&ctid=8c642d1d-d709-47b0-ab10-080af10798fb&experience=power-bi',
  EXPORT: 'https://export.qa.lios.toyota.com',
  GROUPI: 'https://liosapps.qa.toyota.com/groupi',
  SCHEDULE_JOB: 'https://ts.stage.portal.toyotasupplier.com/lios/jobScheduler',
  RETURNS_RELOAD: 'https://ts.stage.portal.toyotasupplier.com/lios/routemgt',
  SCHEDULE_DASHBOARD: 'https://jpe.qa.lios.toyota.com',
  TLMS_SEND: 'https://ts.stage.portal.toyotasupplier.com/lios/tlmssend',
  ALLO: 'https://allo.qa.lios.toyota.com',
  TEMPLATE_URI: "https://template.qa.lios.toyota.com"
};
